<template>
  <div>
    <BaseModal class="upload-info-modal" v-model="isOpenModal">
      <div class="file-uploaded">
        <h2>
          File uploaded
        </h2>
        <table class="results-table text-sm sm:text-md">
          <tr>
            <td>File name</td>
            <td>{{ info.fileName }}</td>
          </tr>
          <tr>
            <td>Original name</td>
            <td>{{ info.originalName }}</td>
          </tr>
          <tr>
            <td>Category</td>
            <td>{{ info.category }}</td>
          </tr>
          <tr v-if="info.subcategory">
            <td>Subcategoru</td>
            <td>{{ info.subcategory }}</td>
          </tr>
          <tr>
            <td>Uploaded date</td>
            <td>{{ info.date | dateWithHours }}</td>
          </tr>
          <tr>
            <td>End processed</td>
            <td>{{ info.dateProcessEnd | dateWithHours }}</td>
          </tr>
          <tr
            v-if="
              info.otherInfoRequest &&
                Object.keys(info.otherInfoRequest).length > 0
            "
          >
            <td>Other Info Request</td>
            <td>{{ info.otherInfoRequest }}</td>
          </tr>
          <tr v-if="info.results && typeof info.results === 'object'">
            <td>Results</td>
            <td>
              {{ info.results.message }}
              <br />
              <div
                v-for="(action, index) in info.results.actions"
                :key="index"
                v-html="action"
              />
              <template v-if="info.results.errorsByType">
                <div
                  v-for="(errors, type) in info.results.errorsByType"
                  :key="type"
                >
                  <template
                    v-if="
                      Array.isArray(errors)
                        ? errors.length > 0
                        : Object.keys(errors).length > 0
                    "
                  >
                    <strong>{{ type.replace(/_/g, " ") }}:</strong>
                    <ul>
                      <li
                        v-for="(count, msg) in Array.isArray(errors)
                          ? {}
                          : errors"
                        :key="msg"
                      >
                        {{ msg }} <em>({{ count }})</em>
                      </li>
                    </ul>
                  </template>
                </div>
              </template>
            </td>
          </tr>
          <tr v-else>
            <td>Results</td>
            <td>{{ info.results }}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{{ info.status }}</td>
          </tr>
          <template v-if="info.results && info.results.filesGenerated">
            <tr
              v-for="(file, index) in info.results.filesGenerated"
              :key="index"
            >
              <td>
                File Generated
              </td>
              <td>
                <button
                  class="btn-dark-button"
                  @click="downloadFile(file.route)"
                >
                  Download "{{ file.name }}" file
                </button>
              </td>
            </tr>
          </template>
        </table>

        <br />
        <button
          class="btn-dark-button"
          @click="downloadFile(info.s3Path, info.s3Url)"
        >
          Download Uploaded File
        </button>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import { signAndDownloadFile } from "@/api/store/UploadFilesService.js";

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    info: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpenModal: this.value
    };
  },
  computed: {
    isOpen() {
      return this.value;
    }
  },
  watch: {
    isOpenModal(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.isOpenModal = val;
    }
  },
  methods: {
    async downloadFile(key, s3Url) {
      if (this.info.category === "assets") {
        window.open(s3Url, "_blank");
        return;
      }
      console.log("s3Path", key);
      const res = await signAndDownloadFile(key, s3Url);
      console.log("res", res);
      if (!res) {
        this.$toast.open({
          message: `Error Downloading file`,
          type: "error",
          position: "top-right"
        });
      }
      return;
    }
  }
};
</script>
<style lang="scss">
.upload-info-modal {
  .modal-content {
    width: fit-content;
    max-width: 100%;
    .file-uploaded {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      h2 {
        font-weight: 700;
        font-size: 20px;
        width: 100%;
        text-align: center;
      }
      table {
        width: 100%;
        table-layout: fixed;
        tr {
          td:first-child {
            width: 150px;
            min-width: 150px;
          }
          td {
            overflow-wrap: break-word;
          }
        }
      }
    }
  }
}
</style>
